import axios from "axios";
import { routes } from "../gen/General";
import { do_logout } from "../sec/actions";
import { useDispatch } from "react-redux";
import { usePolicyMenuStore } from "../store/policy-menu.store";

export const useLogout = () => {
    const { resetPolicyMenu } = usePolicyMenuStore();
    const dispatch = useDispatch();

    const logout = () => {
        const isMobil = sessionStorage.getItem("uqai");
        sessionStorage.clear();
        const url = isMobil ? "/" : "/login/666";
        axios
            .post(routes.root + "/logout")
            .then(() => dispatch(do_logout()))
            .finally(() => {
                resetPolicyMenu();
                window.location.href = url;
            });
    };
    return { logout };
};
